import useLocalStorage from '../../../core/storage/use-local-storage';
import { StorageKey } from '../../../core/storage/storage-key';

export const useShippingAddressId = () => {
  const [shippingAddressId, setShippingAddressId] = useLocalStorage<string | null>(StorageKey.ShippingAddressId, null);

  return { shippingAddressId, setShippingAddressId };
};
